export default __webpack_public_path__ + "static/mfpFrLogo-9a292c5086f47bf2f1e51f4832f4799f.png";